import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import { useTheme } from 'vuetify'

export const useThemeStore = defineStore('theme', () => {
  const vuetifyTheme = useTheme()

  // Get saved theme from localStorage or default to dark
  const savedTheme = localStorage.getItem('theme') || 'dark'
  const isDark = ref(savedTheme === 'dark')

  // Set initial theme using the new API
  vuetifyTheme.change(savedTheme)

  // Watch for theme changes and persist to localStorage
  watch(isDark, (newValue) => {
    const themeName = newValue ? 'dark' : 'light'
    vuetifyTheme.change(themeName)
    localStorage.setItem('theme', themeName)
  })

  const toggleTheme = () => {
    vuetifyTheme.toggle()
    isDark.value = vuetifyTheme.global.current.value.dark
    localStorage.setItem('theme', isDark.value ? 'dark' : 'light')
  }

  const setTheme = (theme: 'light' | 'dark') => {
    vuetifyTheme.change(theme)
    isDark.value = theme === 'dark'
    localStorage.setItem('theme', theme)
  }

  return {
    isDark,
    toggleTheme,
    setTheme
  }
})